import { z } from 'zod';
import { numericSchema } from './shared/numeric-schema';
import { nullableString } from './shared/nullable-string';
import { isoDateSchema } from './shared/iso-date-schema';

// ─── Entity Schema ────────────────────────────────────────────────────────────

export const planetSchema = z.object({
  id: z.string(),
  name: z.string().trim(),
  rotation_period: numericSchema,
  orbital_period: numericSchema,
  diameter: numericSchema,
  climate: nullableString,
  gravity: nullableString,
  terrain: nullableString,
  surface_water: numericSchema,
  population: numericSchema,
  created: isoDateSchema,
  edited: isoDateSchema,
  residents: z.array(z.string()).default([]),
  films: z.array(z.string()).default([]),
});

export type Planet = z.infer<typeof planetSchema>;

// ─── API Response Schemas ─────────────────────────────────────────────────────

export const planetsResponseSchema = z.object({
  planets: z.array(planetSchema),
});

export const planetResponseSchema = z.union([z.object({ planet: planetSchema }), planetSchema]);

export type PlanetsResponse = z.infer<typeof planetsResponseSchema>;
export type PlanetResponse = z.infer<typeof planetResponseSchema>;
